import React, { useState, useEffect } from "react";
import { http } from "../helper";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { Link } from "react-router-dom";
import { BaseUrl } from "../common/config";
import Loader from "../common/loader";
import { useTranslation } from "react-i18next";

const permissionToRouteMap = {
  manage_dashboard: "/dashboard",
  manage_products: "/products",
  manage_product_access_request: "/product-access-requests",
  manage_freeproducts: "/freeproducts",
  manage_newproducts: "/newproducts",
  manage_promotions: "/promotions",
  manage_promooffers: "/promooffers",
  manage_customers: "/vendors",
  manage_foodservicepartners: "/vendorhub/food-service-partner-lead-forms",
  manage_orders: "/orders",
  manage_foodsolutions: "/freesample/freeorders",
  manage_stripelog: "/stripe-paymentlog",
  manage_masterentry: "/master-entry/productgroup",
  manage_chefs: "/development-chef",
  manage_ho: "/headoffice/account",
  manage_users: "/account",
  manage_roles: "/role/",
  manage_emailcampaign: "/email-configuration",
  manage_settings: "/settings",
};

const orderedPermissions = [
  "manage_dashboard",
  "manage_products",
  "manage_product_access_request",
  "manage_freeproducts",
  "manage_newproducts",
  "manage_promotions",
  "manage_promooffers",
  "manage_customers",
  "manage_foodservicepartners",
  "manage_orders",
  "manage_foodsolutions",
  "manage_stripelog",
  "manage_masterentry",
  "manage_chefs",
  "manage_ho",
  "manage_users",
  "manage_roles",
  "manage_emailcampaign",
  "manage_settings",
];

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/products";
    }
  }, []);

  const validateEmail = (email) => {
    const emailRegex =
      /^[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g;
    return emailRegex.test(email);
  };

  const emailChange = (event) => {
    setEmail(event.target.value);
    setLoginStatus("");
    setLoginMessage("");
  };

  const passwordChange = (event) => {
    setPassword(event.target.value);
    setLoginStatus("");
    setLoginMessage("");
  };

  const loginOnSubmit = (event) => {
    event.preventDefault();
    const URL = BaseUrl + "admin/login";
    if (validateEmail(email.toLowerCase().trim())) {
      const payload = {
        email: email.toLowerCase().trim(),
        password,
      };
      setIsLoading(true);
      http
        .post(URL, payload)
        .then((response) => {
          if (response.data.hasOwnProperty("data")) {
            if (response.data.data.status === 200) {
              const userPermissions = response.data.data.adminRole.permissions;
              const accessibleRoute = orderedPermissions
                .filter((permission) => userPermissions.includes(permission))
                .map((permission) => permissionToRouteMap[permission])
                .find((route) => !!route);
              const defaultRoute = "/dashboard";
              sessionStorage.setItem("isLoggedIn", true);
              sessionStorage.setItem(
                "adminEmail",
                response.data.data.adminEmail,
              );
              sessionStorage.setItem("uuid", response.data.data.uuid);
              sessionStorage.setItem("token", response.data.data.token);
              sessionStorage.setItem(
                "authData",
                JSON.stringify(response.data.data),
              );
              if (userPermissions.includes("manage_dashboard")) {
                window.location.href = "/dashboard";
              } else {
                window.location.href = accessibleRoute || defaultRoute;
              }
            } else {
              setLoginMessage(response.data.data.message);
              setLoginStatus(response.data.data.status);
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setLoginStatus(401);
      setLoginMessage(t("valid_email_errmsg_txt"));
    }
  };

  return (
    <div className="login-page">
      <Header />
      {!sessionStorage.getItem("isLoggedIn") && !isLoading && (
        <div className="login">
          <div className="form">
            <form className="login-form" onSubmit={loginOnSubmit}>
              <h2>{t("AdminLogin_txt")}</h2>
              <div className="form-field input-field">
                {loginStatus ? (
                  loginStatus === 401 ? (
                    <div className="error-msg login-error">{loginMessage}</div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                <input
                  type="text"
                  id="accountEmail"
                  value={email}
                  placeholder={t("email_address_txt")}
                  required
                  onChange={emailChange}
                />
              </div>
              <div className="form-field input-field">
                <input
                  type="password"
                  id="accountPassword"
                  value={password}
                  placeholder={t("password_txt")}
                  required
                  onChange={passwordChange}
                />
              </div>
              <button title={t("Login_txt")} type="submit">{t("Login_txt")}</button>
            </form>
            <div className="forget-pass-field">
              <Link className="pass-reset" to="/forgot-password">
                {t("forget_password_txt")}
              </Link>
            </div>
          </div>
        </div>
      )}
      {isLoading && <Loader propsClassName="load-lag" />}
      <Footer />
    </div>
  );
};

export default Login;
